<div id="panel">
  <div class="container-fluid">
    <div class="row">
      <div class="col menu">
        <app-menu></app-menu>
      </div>

      <div class="col content">
        <router-outlet></router-outlet>
      </div>
      <rd-loading *ngIf="validator.errorLoaded"></rd-loading>
    </div>
  </div>
</div>
